import { Stack } from "@mui/material";
import { PostCardSkeleton } from "./PostCardSkeleton";

export function FeedSkeleton() {
  return (
    <Stack
      spacing={2}
      data-testid="feed-skeleton"
      role="status"
      aria-label="Loading posts"
    >
      <PostCardSkeleton />
      <PostCardSkeleton />
      <PostCardSkeleton />
    </Stack>
  );
}
